import { Component } from "@angular/core";
import { FieldType, FieldArrayType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-line",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design"><hr /></div>
    </ng-container>

    <ng-template #other>
      <hr />
    </ng-template>
  `,
})
export class KreFormFieldLine extends FieldType {}
